export default __webpack_public_path__ + "static/media/image4.04ca0ad1.png";